export default __webpack_public_path__ + "static/media/DiaPurchasingTopBanner.68cc2bc1.jpg";